import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './styles/custom-style.css';

// eslint-disable-next-line
import i18n from './config/i18n';

import { LanguageProvider } from './contexts/LanguageContext';
import { WebsiteProvider } from './contexts/WebsiteContext';
import { RestoProvider, useResto } from './contexts/RestoContext';
import { ModeProvider } from './contexts/ModeContext';
import { AuthProvider } from './contexts/AuthContext';

import SiteHeader from './components/SiteHeader/SiteHeader';
import ScrollToTop from './utils/ScrollToTop';
import Home from './pages/Home';
import LegalNotices from './pages/LegalNotices';
import CGU from './pages/CGU';
import PageNotFound from './pages/PageNotFound';
import Login from './pages/Login';
import Faq from './pages/Faq';
import Supplier from './pages/Supplier';
import UpdatePasswordRequest from './pages/UpdatePasswordRequest';
import UpdatePassword from './pages/UpdatePassword';
import Tickets from './pages/Tickets';
import Medias from './pages/Medias';
import CookieConsentBanner from './components/Footer/CookieConsentBanner';
import PageTitleUpdater from './components/PageTitleUpdater';

import Help from './pages/Help';
import Parameters from './pages/Parameters';

import {
  HOME_PATH,
  MEDIAS_PATH,
  FAQ_PATH,
  SUPPLIER_PATH,
  LEGAL_NOTICES_PATH,
  TERMS_OF_USE_PATH,
  LOGIN_PATH,
  PARAMETERS_PATH,
  TICKETS_PATH,
  HELP_PATH,
  UPDATE_PASSWORD_REQUEST_PATH,
  UPDATE_PASSWORD_PATH,
} from './config/routes';

function AppContent() {
  return (
    <Router>
      <PageTitleUpdater />
      <AuthProvider>
        <ScrollToTop />
        <div className="container">
          <SiteHeader />
          <CookieConsentBanner />
          <Routes>
            <Route path={HOME_PATH} element={<Home />} />
            <Route path={MEDIAS_PATH} element={<Medias />} />
            <Route path={FAQ_PATH} element={<Faq />} />
            <Route path={SUPPLIER_PATH} element={<Supplier />} />
            <Route path={LOGIN_PATH} element={<Login />} />
            <Route path={LEGAL_NOTICES_PATH} element={<LegalNotices />} />
            <Route path={TERMS_OF_USE_PATH} element={<CGU />} />
            <Route path={PARAMETERS_PATH} element={<Parameters />} />
            <Route path={TICKETS_PATH} element={<Tickets />} />
            <Route path={HELP_PATH} element={<Help />} />
            <Route path={UPDATE_PASSWORD_REQUEST_PATH} element={<UpdatePasswordRequest />} />
            <Route path={UPDATE_PASSWORD_PATH} element={<UpdatePassword />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

function AppContentWrapper() {
  const { restoData } = useResto();
  if (!restoData) {
    return null;
  }

  return (<AppContent />);
}

function App() {
  return (
    <WebsiteProvider>
      <RestoProvider>
        <LanguageProvider>
          <ModeProvider>
            <AppContentWrapper />
          </ModeProvider>
        </LanguageProvider>
      </RestoProvider>
    </WebsiteProvider>
  );
}

export default App;
